import React, { useEffect, useState } from "react"

import { Row, Col } from "reactstrap"

import Reviews from "./reviews"
import CreatePost from "./CreatePost"
import Notifications from "./notifications"
import Inbox from "./inbox"
import RecentActivity from "./recent-activity"
import WidgetUser from "./widget-user"
import { useSelector, useDispatch, connect } from "react-redux"
import YearlySales from "./yearly-sales"
import LatestTransactions from "./latest-transactions"
import LatestOrders from "./latest-orders"
import PostsList from "./posts_list"

//Import Action to copy breadcrumb items from local state to redux state
import { setBreadcrumbItems } from "../../store/actions"
import SnackbarComponent from "components/SnackBar"
import axios from "axios"
import PostDetails from "./PostDetails"
import Chat from "./chat"
import ReachChart from "./reach"
import ImpressionsChart from "./impressions"
import Miniwidgets from "pages/FacebookDashboard/MiniWidgets"

const FacebookDashboard = props => {
  const [pageDetails, setPageDetails] = useState(null)
  const [err, setErr] = useState(null)
  const [viewMode, setViewMode] = useState("Month")
  const [success, setSuccess] = useState(null)
  const [fromDate, setFromDate] = useState("")
  const [toDate, setToDate] = useState("")
  const [loading, setLoading] = useState(false)
  const [reviews, setReviews] = useState([])
  const [postClicked, setPostClicked] = useState(false)
  const [selectedPost, setSelectedPost] = useState(null)
  const [posts, setPosts] = useState([])
  const [period, setPeriod] = useState("day")
  const [reports, setReports] = useState([])
  const [nextPage, setNextPage] = useState(null)

  const activeOrganization = useSelector(
    state => state.organizationReducer.activeOrganization,
  )

  document.title = "Dashboard | Reputation Management"

  const breadcrumbItems = [
    {
      title: `${activeOrganization.name} (${activeOrganization.type})`,
      link: "/dashboard",
    },
    { title: "Facebook", link: "#" },
  ]
  const fetchInsights = async () => {
    try {
      setLoading(true)
      let period

      const resp = await axios.get(
        `https://graph.facebook.com/v20.0/${activeOrganization?.FacebookIntegrations[0].pageId}`,
        {
          params: {
            access_token: activeOrganization.FacebookIntegrations[0].pageToken,
            fields:
              "fan_count,followers_count,overall_star_rating,rating_count",
          },
        },
      )

      // Fetch page fans (Likes)
      const pageFansResponse = await axios.get(
        `https://graph.facebook.com/v20.0/${activeOrganization?.FacebookIntegrations[0].pageId}/insights`,
        {
          params: {
            access_token: activeOrganization.FacebookIntegrations[0].pageToken,
            metric: "page_fans",
            period: "day",
          },
        },
      )
      if (viewMode === "Month") {
        period = "days_28"

        const pageInsightsResponse = await axios.get(
          `https://graph.facebook.com/v20.0/${activeOrganization?.FacebookIntegrations[0].pageId}/insights`,
          {
            params: {
              access_token:
                activeOrganization.FacebookIntegrations[0].pageToken,
              metric: "page_impressions,page_impressions_unique",
              period: period,
            },
          },
        )

        // Extract data for calculations
        const impressionsValues =
          pageInsightsResponse.data.data[0]?.values || []
        const reachValues = pageInsightsResponse.data.data[1]?.values || []

        // Calculate percentage differences
        const calculatePercentageDifference = (current, previous) => {
          if (previous === 0) return "+0%"
          const diff = ((current - previous) / previous) * 100
          const sign = diff > 0 ? "+" : ""
          return `${sign}${diff.toFixed(2)}%`
        }

        const impressionsCurrent = impressionsValues[1]?.value || 0
        const impressionsPrevious = impressionsValues[0]?.value || 0
        const impressionsDiff = calculatePercentageDifference(
          impressionsCurrent,
          impressionsPrevious,
        )
        const impressionsBadgeColor =
          impressionsCurrent >= impressionsPrevious ? "info" : "danger"

        const reachCurrent = reachValues[1]?.value || 0
        const reachPrevious = reachValues[0]?.value || 0
        const reachDiff = calculatePercentageDifference(
          reachCurrent,
          reachPrevious,
        )
        const reachBadgeColor =
          reachCurrent >= reachPrevious ? "info" : "danger"

        setReports([
          {
            title: "Followers",
            iconClass: "account-group",
            total: `${resp.data.followers_count || 0}`,
            average: null,
            badgecolor: "info",
          },
          {
            title: "Likes",
            iconClass: "thumb-up",
            total: pageFansResponse.data.data[0]?.values[1]?.value || 0,
            average: null,
            badgecolor: "info",
          },
          {
            title: "Reach",
            iconClass: "message-draw",
            total: reachCurrent,
            average: reachDiff,
            badgecolor: reachBadgeColor,
          },
          {
            title: "Impressions",
            iconClass: "star",
            total: impressionsCurrent,
            average: impressionsDiff,
            badgecolor: impressionsBadgeColor,
          },
        ])
      } else if (viewMode === "Week") {
        period = "week"

        const pageInsightsResponse = await axios.get(
          `https://graph.facebook.com/v20.0/${activeOrganization?.FacebookIntegrations[0].pageId}/insights`,
          {
            params: {
              access_token:
                activeOrganization.FacebookIntegrations[0].pageToken,
              metric: "page_impressions,page_impressions_unique",
              period: period,
            },
          },
        )

        // Extract data for calculations
        const impressionsValues =
          pageInsightsResponse.data.data[0]?.values || []
        const reachValues = pageInsightsResponse.data.data[1]?.values || []

        // Calculate percentage differences
        const calculatePercentageDifference = (current, previous) => {
          if (previous === 0) return "+0%"
          const diff = ((current - previous) / previous) * 100
          const sign = diff > 0 ? "+" : ""
          return `${sign}${diff.toFixed(2)}%`
        }

        const impressionsCurrent = impressionsValues[1]?.value || 0
        const impressionsPrevious = impressionsValues[0]?.value || 0
        const impressionsDiff = calculatePercentageDifference(
          impressionsCurrent,
          impressionsPrevious,
        )
        const impressionsBadgeColor =
          impressionsCurrent >= impressionsPrevious ? "info" : "danger"

        const reachCurrent = reachValues[1]?.value || 0
        const reachPrevious = reachValues[0]?.value || 0
        const reachDiff = calculatePercentageDifference(
          reachCurrent,
          reachPrevious,
        )
        const reachBadgeColor =
          reachCurrent >= reachPrevious ? "info" : "danger"

        setReports([
          {
            title: "Followers",
            iconClass: "account-group",
            total: `${resp.data.followers_count || 0}`,
            average: null,
            badgecolor: "info",
          },
          {
            title: "Likes",
            iconClass: "thumb-up",
            total: pageFansResponse.data.data[0]?.values[1]?.value || 0,
            average: null,
            badgecolor: "info",
          },
          {
            title: "Reach",
            iconClass: "message-draw",
            total: reachCurrent,
            average: reachDiff,
            badgecolor: reachBadgeColor,
          },
          {
            title: "Impressions",
            iconClass: "star",
            total: impressionsCurrent,
            average: impressionsDiff,
            badgecolor: impressionsBadgeColor,
          },
        ])
      } else {
        let currentStartDate = new Date(fromDate)
        let currentEndDate = new Date(toDate)

        const daysInRange =
          (currentEndDate - currentStartDate) / (1000 * 60 * 60 * 24)

        // Limit the maximum allowed date range to 93 days to comply with Facebook API
        const MAX_DAYS_ALLOWED = 180
        if (daysInRange > MAX_DAYS_ALLOWED) {
          console.warn(
            "Date range too large, reducing to maximum allowed days.",
          )
          setErr("Date Range exceeded, cannot be greater than 6 months")
          return
        }

        // Determine period groups
        const PERIOD_GROUP =
          daysInRange > 28 ? 28 : daysInRange > 7 ? 7 : daysInRange

        let totalImpressionsCurrent = 0
        let totalImpressionsPrevious = 0
        let totalReachCurrent = 0
        let totalReachPrevious = 0

        for (let i = 0; i < daysInRange; i += PERIOD_GROUP) {
          let groupStartDate = new Date(currentStartDate)
          groupStartDate.setDate(groupStartDate.getDate() + i)
          let groupEndDate = new Date(groupStartDate)
          groupEndDate.setDate(groupStartDate.getDate() + PERIOD_GROUP - 1)
          if (groupEndDate > currentEndDate) groupEndDate = currentEndDate

          let previousGroupStartDate = new Date(groupStartDate)
          previousGroupStartDate.setDate(
            previousGroupStartDate.getDate() - daysInRange,
          )
          let previousGroupEndDate = new Date(groupEndDate)
          previousGroupEndDate.setDate(
            previousGroupEndDate.getDate() - daysInRange,
          )

          try {
            const pageInsightsResponse = await axios.get(
              `https://graph.facebook.com/v20.0/${activeOrganization?.FacebookIntegrations[0].pageId}/insights`,
              {
                params: {
                  access_token:
                    activeOrganization.FacebookIntegrations[0].pageToken,
                  metric: "page_impressions,page_impressions_unique",
                  period: "day",
                  since: Math.floor(groupStartDate.getTime() / 1000),
                  until: Math.floor(groupEndDate.getTime() / 1000),
                },
              },
            )

            const previousInsightsResponse = await axios.get(
              `https://graph.facebook.com/v20.0/${activeOrganization?.FacebookIntegrations[0].pageId}/insights`,
              {
                params: {
                  access_token:
                    activeOrganization.FacebookIntegrations[0].pageToken,
                  metric: "page_impressions,page_impressions_unique",
                  period: "day",
                  since: Math.floor(previousGroupStartDate.getTime() / 1000),
                  until: Math.floor(previousGroupEndDate.getTime() / 1000),
                },
              },
            )

            // Sum values for each group
            const sumMetricValues = values =>
              values.reduce((sum, item) => sum + (item.value || 0), 0)

            totalImpressionsCurrent += sumMetricValues(
              pageInsightsResponse.data.data[0]?.values || [],
            )
            totalImpressionsPrevious += sumMetricValues(
              previousInsightsResponse.data.data[0]?.values || [],
            )

            totalReachCurrent += sumMetricValues(
              pageInsightsResponse.data.data[1]?.values || [],
            )
            totalReachPrevious += sumMetricValues(
              previousInsightsResponse.data.data[1]?.values || [],
            )
          } catch (error) {
            console.error("Error fetching insights:", error)
            setErr("Error fetching insights.")
            return
          }
        }

        // Calculate percentage differences
        const calculatePercentageDifference = (current, previous) => {
          if (previous === 0) return "+0%"
          const diff = ((current - previous) / previous) * 100
          const sign = diff > 0 ? "+" : ""
          return `${sign}${diff.toFixed(2)}%`
        }

        const impressionsDiff = calculatePercentageDifference(
          totalImpressionsCurrent,
          totalImpressionsPrevious,
        )
        const reachDiff = calculatePercentageDifference(
          totalReachCurrent,
          totalReachPrevious,
        )

        console.log("Current period total reach: ", totalReachCurrent)
        console.log("Previous period total reach: ", totalReachPrevious)

        setReports([
          {
            title: "Followers",
            iconClass: "account-group",
            total: `${resp.data.followers_count || 0}`,
            average: null,
            badgecolor: "info",
          },
          {
            title: "Likes",
            iconClass: "thumb-up",
            total: pageFansResponse.data.data[0]?.values[1]?.value || 0,
            average: null,
            badgecolor: "info",
          },
          {
            title: "Reach",
            iconClass: "message-draw",
            total: totalReachCurrent,
            average: reachDiff,
            badgecolor:
              totalReachCurrent >= totalReachPrevious ? "info" : "danger",
          },
          {
            title: "Impressions",
            iconClass: "star",
            total: totalImpressionsCurrent,
            average: impressionsDiff,
            badgecolor:
              totalImpressionsCurrent >= totalImpressionsPrevious
                ? "info"
                : "danger",
          },
        ])
      }

      setLoading(false)
    } catch (err) {
      setErr("Error Fetching Insights.")
      console.log(err)
      setLoading(false)
    }
  }

  const fetchReviews = async () => {
    setLoading(true)

    try {
      const response = await axios.get(
        `https://graph.facebook.com/v20.0/${activeOrganization?.FacebookIntegrations[0].pageId}/ratings`,
        {
          params: {
            access_token: activeOrganization.FacebookIntegrations[0].pageToken,
            fields:
              "id,from,reviewer{name,picture},created_time,recommendation_type,review_text",
          },
        },
      )

      setReviews(response.data.data)
      setLoading(false)
    } catch (err) {
      console.log(err)
      setErr("Error Fetching reviews.")
      setLoading(false)
    }
  }

  const loadMorePosts = async () => {
    if (!nextPage) return // No more pages to load

    try {
      setLoading(true)
      const response = await axios.get(nextPage) // Use the next page URL
      console.log("More posts", response.data.data)

      setPosts(prevPosts => [...prevPosts, ...response.data.data]) // Append new posts
      setNextPage(response.data.paging?.next || null) // Update next page URL
      setLoading(false)
    } catch (err) {
      console.error("Error fetching more posts", err)
      setErr("Error loading more posts.")
    }
  }

  const fetchPosts = async () => {
    try {
      setLoading(true)
      const response = await axios.get(
        `https://graph.facebook.com/v20.0/${activeOrganization?.FacebookIntegrations[0].pageId}/posts?fields=message,attachments{media_type,media,url},full_picture,created_time,reactions{name,id},comments{message,created_time,from}&access_token=${activeOrganization?.FacebookIntegrations[0].pageToken}`,
      )
      console.log("piosts", response.data.data)
      setPosts(response.data.data)
      setNextPage(response.data.paging?.next || null)
      setLoading(false)
    } catch (err) {
      setPosts(null)
      setErr("Error fetching posts.")
    }
  }

  useEffect(() => {
    props.setBreadcrumbItems(`Facebook`, breadcrumbItems)
    fetchReviews()
    fetchPosts()
  }, [])

  useEffect(() => {
    fetchInsights()
  }, [viewMode])

  return (
    <React.Fragment>
      <SnackbarComponent
        err={err}
        success={success}
        setErr={setErr}
        setSuccess={setSuccess}
      />
      {postClicked ? (
        <PostDetails
          postId={selectedPost}
          setErr={setErr}
          setSuccess={setSuccess}
          setPostClicked={setPostClicked}
          setSelectedPost={setSelectedPost}
        />
      ) : (
        <>
          <Miniwidgets
            reports={reports}
            setViewMode={setViewMode}
            viewMode={viewMode}
            loading={loading}
            callBack={fetchInsights}
            fromDate={fromDate}
            toDate={toDate}
            setFromDate={setFromDate}
            setToDate={setToDate}
          />

          <Row>
            <Col xl="6">
              {/* Monthly Earnings */}
              <ReachChart />
            </Col>

            <Col xl="6">
              {/* Email sent */}
              <ImpressionsChart />
            </Col>

            {/* <Col xl="3">
              <Notifications followersByCity={followersByCity} />
            </Col> */}
          </Row>
          <Row>
            <Col xl="12">
              {/* Monthly Earnings */}
              <Reviews reviews={reviews} loading={loading} />
            </Col>
            {/* <Col xl="3">
              <Notifications followersByCity={followersByCity} />
            </Col> */}
          </Row>

          <Row>
            <Col xl={12}>
              <PostsList
                reviews={posts}
                setPostClicked={setPostClicked}
                setSelectedPost={setSelectedPost}
              />
            </Col>
          </Row>

          {/* <Row>
            <Col xl="4" lg="6">
              <Inbox />
            </Col>
            <Col xl="4" lg="6">
              <RecentActivity />
            </Col>
            <Col xl="4">
              <WidgetUser />
              <YearlySales />
            </Col>
          </Row> */}

          <Row>
            <Col xl="12">
              <Chat setErr={setErr} />
            </Col>
          </Row>
        </>
      )}
    </React.Fragment>
  )
}

export default connect(null, { setBreadcrumbItems })(FacebookDashboard)
